import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_CREATE_PROPORTIONAL__DISBURSEMENT } from "../../../config/api";

export const submitProportionalPayout = createAsyncThunk(
  "disburse/create",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_CREATE_PROPORTIONAL__DISBURSEMENT,
        data: data?.data || data,
      });

      toast.success(response?.data?.message);
      data.callback();
      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      data?.fail();
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
